export const settingsOutlet = 'settings';
